import Vue from 'vue';
import { PartnerDocebo } from '@/service';

function _ringCourses(state, name, type = 'courses') {
	let ring = state.rings.find((r) => r.name === name);
	let courses = state.courses.filter((c) => ring[type].includes(c.course_id));
	return courses;
}

/**
 * @class @name Webinar
 * @description Exposes menu store module
 */
export default class Webinar {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	static get state() {
		return {
			authStatus: null,
			courses: [],
			catalogs: {},
			rings: [
				{
					name: 1,
					courses: [4, 9, 13, 14, 15, 16, 17, 18, 118, 190],
					mot: [361, 322],
					sortFunction: [(c) => Number(c.id_course) === 361 ? 2 : Number(c.id_course) === 322 ? 1 : 0, (c) => Number(c.id_course)], //361 first, 322 second then everything else in id_course ascending
					sortOrder: ['desc', 'asc']
				},
				{
					name: 2,
					courses: [171, 172, 173, 174]
				},
				{
					name: 4,
					courses: [241, 240, 239, 238, 237, 236, 235, 234, 232, 231, 230, 332, 416, 310, 309, 308, 278, 256, 255, 248, 246, 244, 243, 242, 396, 395, 394, 393, 392, 391, 397, 398, 399, 400, 401, 402, 403, 386, 385, 384, 383, 382, 381, 380, 379, 378, 329, 328, 327, 326, 325, 390, 389, 388, 387, 387, 377, 376, 375, 374, 373, 372, 371, 370, 369, 368, 367, 366, 365, 364, 363, 362, 333, 331, 330, 305, 306, 256, 255, 248, 246, 244, 243, 242],
					sortFunction: [(c) => Number(c.id_course)],
					sortOrder: ['desc']
				}
			]
		};
	}

	/**
	 * @method @static @get @name getters
	 * @description Expose getters as an object, compatible with vue stores
	 */
	static get getters() {
		return {
			/**
			 * @name ringOneCourses
			 * @description TODO
			 * @return {Array}
			 */
			ringOneCourses: (state) => {
				return _ringCourses(state, 1, 'courses');
			},

			/**
			 * @name getCatalogWithEnrolment
			 * @description TODO
			 * @return {Array}
			 */
			getCatalogWithEnrolment: (state) => (ringId, catalogId) => {
				let ring = state.rings.find((r) => r.name === ringId);
				let catalog = state.catalogs[catalogId];
				if (!ring) return [];
				if (!catalog) return [];
				// Only display courses that we have hardcoded as being included
				let items = catalog.filter((c) => ring.courses.includes(Number(c.item_id)));
				// Mapping required for correct dispaly in UI component
				let courses = items.map((x) => {
					x.name = x.item_name;
					x.id_course = x.item_id;
					x.image = x.item_thumbnail;
					// Am I enrolled?
					let enrolledCourse = state.courses.find((c) => c.course_id == x.id_course);
					if (enrolledCourse) Vue.set(x, 'enrollment_status', enrolledCourse.enrollment_status);
					return x;
				});
				return courses;
			},

			/**
			 * @name getRingSortOption
			 * @description TODO
			 * @return {Array}
			 */
			getRingSortOption: (state) => (id) => {
				let ring = state.rings.find((r) => r.name === id);
				if (!ring) return [];
				return {
					fnctn: ring.sortFunction,
					order: ring.sortOrder
				};
			},

			/**
			 * @name getRingMot
			 * @description TODO
			 * @return {Array}
			 */
			getRingMot: (state) => (id, catalogId) => {
				let ring = state.rings.find((r) => r.name === id);
				let catalog = state.catalogs[catalogId];
				if (!ring) return [];
				if (!ring.mot) return [];
				if (!catalog) return [];

				// Only display mot that we have hardcoded as being included
				let items = catalog.filter((c) => ring.mot.includes(Number(c.item_id)));
				// Mapping required for correct dispaly in UI component
				let mot = items.map((x) => {
					x.name = x.item_name;
					x.id_course = x.item_id;
					x.image = x.item_thumbnail;
					// Am I enrolled?
					let enrolledCourse = state.courses.find((y) => y.course_id == x.id_course);
					if (enrolledCourse) Vue.set(x, 'enrollment_status', enrolledCourse.enrollment_status);
					return x;
				}).filter((c) => c.enrollment_status); //only display MOT if enrolled
				return mot;
			}
		};
	}

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	static get mutations() {
		return {
			/**
			 * @name setAuthStatus
			 * @param {Object} state
			 * @param {Object} data
			 */
			setAuthStatus(state, data) {
				state.authStatus = data;
			},

			/**
			 * @name setCourses
			 * @param {Object} state
			 * @param {Object} data
			 */
			setCourses(state, data) {
				state.courses = data;
			},

			/**
			 * @name setCatalogs
			 * @param {Object} state
			 * @param {Object} data
			 */
			setCatalogs(state, data) {
				state.catalogs = data;
			},

			/**
			 * @name setCourses
			 * @param {Object} state
			 * @param {Object} payload
			 */
			setCatalogContent(state, payload) {
				Vue.set(state.catalogs, payload.catalogId, payload.data);
			}
		};
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @async @name getCourseList
			 * @param {function} commit
			 */
			async getCourseList({ commit }) {
				commit('setAuthStatus', null);
				commit('setCourses', []);
				return PartnerDocebo.enrollments()
					.then(({ data }) => {
						commit('setAuthStatus', 'success');
						commit('setCourses', data);
					})
					.catch(() => {
						commit('setAuthStatus', 'error');
					});
			},

			/**
			 * @async @name getCatalogContent
			 * @param {function} commit
			 */
			async getCatalogContent({ commit }, catalogId) {
				commit('setCatalogs', {});
				return PartnerDocebo.catalogContent(catalogId)
					.then(({ data }) => commit('setCatalogContent', { catalogId, data: data.data.items[0].data.sub_items }))
					.catch(() => {});
			},

			/**
			 * @async @name updateUser
			 * @param {function} commit
			 */
			// eslint-disable-next-line no-unused-vars
			async updateUser({ commit }, data) {
				return PartnerDocebo.updateUser(data.id, data.payload).catch(() => {});
			},

			/**
			 * @async @name setAuthStatus
			 * @param {function} commit
			 */
			async setAuthStatus({ commit }, val) {
				commit('setAuthStatus', val);
			},

			/**
			 * @async @name setCourses
			 * @param {function} commit
			 */
			async setCourses({ commit }, val) {
				commit('setCourses', val);
			}
		};
	}
}
